/*
 *		Copyright (c) 2011-2018 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Translate')
    .config(['$translateProvider', 'ENV', function($translateProvider, ENV) {
        $translateProvider.preferredLanguage(ENV.defaultLocale);
        $translateProvider.fallbackLanguage(ENV.defaultLocale);

        // we want to allow < and >, angular handles the escaping unless we specify trustAsHtml for the string
        // if we choose escape or escapeParameters strategy the values are escaped twice
        // and < > are displayed as &lt; and &gt;
        $translateProvider.useSanitizeValueStrategy(null);

        // add optional interpolation strategy for 'messageformat'
        // use as a third argument for translations when needed
        // translate directive: {{ 'Active User' | translate: {COUNT: 1}:'messageformat' }}
        // $translate service: $translate.instant('Active User', {COUNT: 3}, 'messageformat')
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
    }]);
